.Root {
  text-align: -webkit-center;
  width: 100%;
  height: 100%;
  margin-top: 200px auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
